import { InlineBanner } from "@sportsmet/ui";
import { useQueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";

import { retryAfterOffline } from "./retryAfterOffline";
import { useOnlineStatus } from "./useOnlineStatus";

export const OfflineBanner = (): ReactNode => {
  const online = useOnlineStatus();
  const queryClient = useQueryClient();

  if (online) return null;

  return (
    <div className="mx-auto w-full max-w-[960px] px-4 pt-3">
      <InlineBanner
        variant="offline"
        message="You're offline. We're showing what we saved."
        action={{
          label: "Try again",
          onAction: () => {
            void retryAfterOffline(queryClient);
          },
        }}
      />
    </div>
  );
};
